import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-7" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';

import { ref, computed, onMounted } from 'vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import IllnessCondition from '@/classes/IllnessCondition';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route = useRoute();

const illnessConditionId = route.params.id as unknown as string;

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)

const payload = ref({
    id: illnessConditionId,
    name: null
});

const updateIllnessCondition = () => {
    loader.value = true;

    IllnessCondition.updateIllnessCondition(illnessConditionId, payload.value)
        .then(() => {
            loader.value      = false;
            showSuccess.value = true;

            setTimeout(() => {
                window.location.replace(`/contents/conditions`);
            }, 2000);
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const editIllnessCondition = () => {
    loader.value = true;

    IllnessCondition.editIllnessCondition(illnessConditionId)
        .then((result: any) => {
            loader.value = false;
            payload.value.name = result.data.illnessCondition.name;
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}


// const clearFields = () => {
//     payload.value.name = null;
// }

// Tabs
const tabs: { name: string, count: number, allowed: boolean }[] = computed(() => [
    {
        name: 'Information',
        count: 0,
        href: `/contents/conditions/edit/${illnessConditionId}`,
        allowed: true
    }
]);

onMounted(() => {
    editIllnessCondition()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Illness/Condition",
    "show-back": "",
    backUrl: "/contents/conditions"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs.value }, null, 8, ["tabs"])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, { form: payload.value }, {
          default: _withCtx(() => [
            (_ctx.$hasPermission('update-content'))
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true))
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" Save Changes ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["form"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Confirm",
        title: "Illness/Condition Updated!",
        content: "Illness/Condition has been Updated successfully"
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[5] || (_cache[5] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => {showConfirmation.value = false; updateIllnessCondition() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Submit Illness/Condition?",
        content: "Are you sure you wish to submit this Illness/Condition?"
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})